"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSliceState = void 0;
const actionTypes_1 = require("./actionTypes");
const thunkReducer_1 = __importDefault(require("./thunkReducer"));
exports.defaultSliceState = {
    thunks: [],
    queue: []
};
const sliceReducer = (state, action) => {
    switch (action.type) {
        case actionTypes_1.THUNKTANK_ENQUEUE: {
            const { queuedAction } = action;
            return Object.assign(Object.assign({}, state), { queue: [
                    ...state.queue,
                    queuedAction
                ] });
        }
        case actionTypes_1.THUNKTANK_UNQUEUE: {
            return Object.assign(Object.assign({}, state), { queue: state.queue.slice(1) });
        }
        case actionTypes_1.THUNKTANK_INIT: {
            return state;
        }
        default:
            const { thunkIndex } = action, thunkAction = __rest(action, ["thunkIndex"]);
            if (thunkIndex === undefined)
                return null;
            const defaultThunkState = {
                isDeleted: false,
                isLoading: false,
                error: null,
                data: null
            };
            const newState = Object.assign({}, state);
            let currentThunk = newState.thunks[thunkIndex] || defaultThunkState;
            if (currentThunk.isDeleted && thunkAction.type === actionTypes_1.THUNKTANK_ADD) {
                currentThunk = defaultThunkState;
            }
            const newThunkState = (0, thunkReducer_1.default)(currentThunk, thunkAction);
            if (!newThunkState)
                return null;
            newState.thunks[thunkIndex] = newThunkState;
            return newState;
    }
};
exports.default = sliceReducer;
